interface IProps {
    children?: React.ReactNode;
}

export default function CardSubHeader(props: IProps) {
    return <div className="userful-card-sub-header">{props.children}</div>;
}
